import { render, staticRenderFns } from "./TermsOfServiceHeader.vue?vue&type=template&id=016b0ce2&scoped=true&"
import script from "./TermsOfServiceHeader.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServiceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfServiceHeader.vue?vue&type=style&index=0&id=016b0ce2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b0ce2",
  null
  
)

export default component.exports